export const QueryKey = {
  me: ['me'],
  teacher: {
    noticeList: ['teacher', 'noticeList'],
    notice: ['teacher', 'notice'],
    boardList: ['teacher', 'boardList'],
    board: ['teacher', 'board'],
    newsletterList: ['teacher', 'newsletterList'],
    newsletter: ['teacher', 'newsletter'],
  },
} as const;
